import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy(event) {
    const value = event.params.value
    if (!value) return
    this.#writeToClipboard(event.currentTarget, value)
  }

  copyChunk(event) {
    const chunk = event.params.value
    if (!chunk) return
    this.#writeToClipboard(event.currentTarget, `"${chunk}"`)
  }

  toggleSplit(event) {
    const isSplit = event.currentTarget.checked
    const root    = event.currentTarget.closest('[data-controller="mailbox-wizard"]')

    root.querySelectorAll('[data-dkim-normal]').forEach(row => {
      row.classList.toggle('d-none', isSplit)
    })
    root.querySelectorAll('[data-dkim-split-row]').forEach(row => {
      row.classList.toggle('d-none', !isSplit)
    })
  }

  #writeToClipboard(btn, value) {
    navigator.clipboard.writeText(value).then(() => {
      const originalHtml = btn.innerHTML
      btn.innerHTML = '<i class="bi bi-check-lg text-success"></i>'
      btn.classList.replace('btn-outline-secondary', 'btn-outline-success')
      setTimeout(() => {
        btn.innerHTML = originalHtml
        btn.classList.replace('btn-outline-success', 'btn-outline-secondary')
      }, 2000)
    })
  }
}
